import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ToolbarPortal from './ToolbarPortal';

import ToolbarSpacer from 'components/Toolbar/ToolbarSpacer';
import ToolbarActions from 'components/Toolbar/ToolbarActions';

interface Props {
  preContent?: React.ReactNode;
  dirty?: boolean;
  rightSide?: boolean;
  children: any;
}

// (note - pearl) This needs to be used within the new Page component for the portal to work
// properly (import Page from 'components/Page/newComponents')
function PageFormToolbar({ dirty, preContent, rightSide, children }: Props) {
  const classes = useStyles();

  return (
    <ToolbarPortal>
      <div
        className={classNames(classes.root, {
          [classes.visible]: dirty,
        })}
        data-testid="page-form-toolbar"
      >
        <ToolbarSpacer />
        {preContent}
        <ToolbarActions rightSide={rightSide}>{children}</ToolbarActions>
      </div>
    </ToolbarPortal>
  );
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      borderTop: 'solid 1px #e6e6e6',
      display: 'flex',
      flex: '0 0 auto',
      overflowY: 'hidden',
      transition: 'min-height .4s',
      height: 0,
      minHeight: 0,
      backgroundColor: theme.palette.common.white,
      alignItems: 'center',
      width: '100vw',
    },
    visible: {
      minHeight: 70,
      padding: theme.spacing(2),
    },
  };
});

export default PageFormToolbar;
